import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('uk');
    // Restore saved language preference or use default
    const savedLang = localStorage.getItem('spectator-lang');
    translate.use(savedLang && (savedLang === 'uk' || savedLang === 'en') ? savedLang : 'uk');
  }
}
